export default __webpack_public_path__ + "static/media/loading.1ca6a2d9.gif";